import { useTheme, useMediaQuery } from "@mui/material";
import { Icon, Tooltip } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";

import ArgonBox from "components/ArgonBox";
import ArgonButton from "components/ArgonButton";
import ArgonInput from "components/ArgonInput";
import ArgonTypography from "components/ArgonTypography";
import { useArgonController } from "context";

const NewColumnForm = ({ open, title, onChange, onSubmit, onClose }) => {
  const [controller] = useArgonController();
  const { darkMode } = controller;
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "lg"));

  if (!open) return null;

  return (
    <ArgonBox
      sx={{
        backgroundColor: darkMode ? "background.dark" : "#ffffff",
        p: 2,
        borderRadius: 2,
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        position: "absolute",
        right: 0,
        top: "100%",
        mt: 1,
        zIndex: 9999,
        width: isTablet ? theme.functions.pxToRem(250) : theme.functions.pxToRem(300),
      }}
    >
      <ArgonBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <ArgonTypography variant="h6">Nuova Colonna</ArgonTypography>
        <Tooltip title="Close">
          <Icon sx={{ cursor: "pointer" }} onClick={onClose}>
            close
          </Icon>
        </Tooltip>
      </ArgonBox>
      <ArgonInput placeholder="Titolo colonna" value={title} onChange={onChange} fullWidth />
      <ArgonBox display="flex" mt={2} justifyContent="flex-end">
        <ArgonButton variant="gradient" color="primary" size="small" onClick={onSubmit}>
          Aggiungi
        </ArgonButton>
        <ArgonBox ml={1}>
          <ArgonButton variant="gradient" color="light" size="small" onClick={onClose}>
            Annulla
          </ArgonButton>
        </ArgonBox>
      </ArgonBox>
    </ArgonBox>
  );
};

NewColumnForm.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.string,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  onClose: PropTypes.func,
};

NewColumnForm.defaultProps = {
  open: false,
  title: "",
  onChange: () => {},
  onSubmit: () => {},
  onClose: () => {},
};

export default NewColumnForm;
